<template>
  <div class="statistics">
    <b-nav tabs class="statistics-tabs" small>
      <b-nav-item 
        class="statistics-tabs-item" 
        v-if="isAdmin || isJournalism || isMarketing || isEditor" 
        :active="reportByUserActive"
        @click="openReportByUser"
      >
        {{ $t('STATISTICS').Report_By_User }}
      </b-nav-item>
      <b-nav-item 
        class="statistics-tabs-item" 
        v-if="isAdmin || isMarketing || isContract" 
        :active="reportLeadsActive"
        @click="openReportLeads"
      >
        {{ $t('STATISTICS').Report_Leads }}
      </b-nav-item>
      <b-nav-item 
        class="statistics-tabs-item" 
        v-if="isAdmin || isMarketing || isContract" 
        :active="reportDemoRequestActive"
        @click="openReportDemoRequest"
      >
        {{ $t('STATISTICS').Report_Demo }}
      </b-nav-item>
      <b-nav-item 
        class="statistics-tabs-item" 
        v-if="isAdmin || isMarketing || isContract" 
        :active="clientProfileUpdateActive"
        @click="openClientProfileUpdate"
      >
        {{ $t('STATISTICS').Client_Profile_Update }}
      </b-nav-item>
      <b-nav-item 
        class="statistics-tabs-item" 
        v-if="isAdmin || isConsulting || isMarketing || isEditor" 
        :active="analyticsSystemContentActive"
        @click="openAnalyticsSystemContent"
      >
        {{ $t('STATISTICS').Statistics_Subject_Content }}
      </b-nav-item>
      <b-nav-item 
        class="statistics-tabs-item" 
        v-if="isAdmin || isConsulting || isJournalism || isMarketing" 
        :active="controlContentViewActive"
        @click="openControlContentView"
      >
        {{ $t('STATISTICS').Control_Content_View }}
      </b-nav-item>
    </b-nav>
    <report-by-user v-if="reportByUserActive && (isAdmin || isJournalism || isMarketing || isEditor)" />
    <report-leads v-if="reportLeadsActive && (isAdmin || isMarketing || isContract)" />
    <report-demo-request v-if="reportDemoRequestActive && (isAdmin || isMarketing || isContract)" />
    <update-client-profile v-if="clientProfileUpdateActive && (isAdmin || isMarketing || isContract)" />
    <analytics-system-content v-if="analyticsSystemContentActive && (isAdmin || isConsulting || isMarketing || isEditor)" />
    <control-content-view v-if="controlContentViewActive && (isAdmin || isConsulting || isJournalism || isMarketing)" />

  </div>
</template>

<script>
import ReportByUser from '../report/ReportByUser.vue'
import ReportLeads from '../report/ReportLeads.vue'
import {
  BNav, 
  BNavItem,
} from "bootstrap-vue";
import AppConstants from '@/appConstants';
import ReportDemoRequest from '../report/ReportDemoRequest.vue';
import UpdateClientProfile from '../report/UpdateClientProfile.vue';
import AnalyticsSystemContent from '../report/AnalyticsSystemContent.vue';
import ControlContentView from '../report/ControlContentView.vue';

export default {
  components: {
    ReportByUser,
    ReportLeads,
    BNav, 
    BNavItem,
    ReportDemoRequest,
    UpdateClientProfile,
    AnalyticsSystemContent,
    ControlContentView
  },
  data() {
    return {
      reportByUserActive: false,
      reportLeadsActive: false,
      reportDemoRequestActive: false,
      clientProfileUpdateActive: false,
      analyticsSystemContentActive: false,
      controlContentViewActive: false
    }
  },
  created() {
    this.setInitialActiveTab();
  },
  computed: {
    userData() {
      return this.$store.state.auth.currentUser || {};
    },
    isAdmin() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.ADMIN) {
          return true;
        }
      }
      return false;
    },
    isPublisher() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.PUBLISHER) {
          return true;
        }
      }
      return false;
    },
    isJournalism() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.JOURNALISM) {
          return true;
        }
      }
      return false;
    },
    isConsulting() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.CONSULTING) {
          return true;
        }
      }
      return false;
    },
    isMarketing() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.MARKETING) {
          return true;
        }
      }
      return false;
    },
    isContract() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.CONTRACT) {
          return true;
        }
      }
      return false;
    },
    isEditor() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.EDITOR) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    setInitialActiveTab() {
      if (this.isAdmin || this.isJournalism || this.isMarketing || this.isEditor) {
        this.openReportByUser();
      } else if (this.isAdmin || this.isMarketing || this.isContract) {
        this.openReportLeads();
      } else if (this.isAdmin || this.isConsulting || this.isMarketing || this.isEditor) {
        this.openAnalyticsSystemContent();
      } else if (this.isAdmin || this.isConsulting || this.isJournalism || this.isMarketing) {
        this.openControlContentView();
      }
    },
    openReportByUser() {
      this.resetAllTabs();
      this.reportByUserActive = true;
    },

    openReportLeads() {
      this.resetAllTabs();
      this.reportLeadsActive = true;
    },

    openReportDemoRequest() {
      this.resetAllTabs();
      this.reportDemoRequestActive = true;
    },

    openClientProfileUpdate() {
      this.resetAllTabs();
      this.clientProfileUpdateActive = true;
    },

    openAnalyticsSystemContent() {
      this.resetAllTabs();
      this.analyticsSystemContentActive = true;
    },

    openControlContentView() {
      this.resetAllTabs();
      this.controlContentViewActive = true;
    },

    resetAllTabs() {
      this.reportByUserActive = false;
      this.reportLeadsActive = false;
      this.reportDemoRequestActive = false;
      this.clientProfileUpdateActive = false;
      this.analyticsSystemContentActive = false;
      this.controlContentViewActive = false;
    }
  }
}
</script>

<style>

.statistics {
  display: flex;
  flex-direction: column;
  margin-top: -10px;
  height: 100%;
  width: 100%;
}

.statistics .statistics-tabs {
  padding: 1rem;
}

.statistics .statistics-tabs .statistics-tabs-item {
  padding-right: 1.5rem;
}

.statistics .nav-tabs {
  margin-bottom: 0;
}

.nav.statistics-tabs.nav-tabs .nav-link.active {
  border-radius: 5px;
}

.statistics-tabs-item .nav-link.active {
  border-bottom: 1px solid #e1dfe4;
}

</style>